/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Precheck_Ignore_AllInputs */

const en_embed_captions_precheck_ignore_all = /** @type {(inputs: Embed_Captions_Precheck_Ignore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignore All`)
};

const fr_embed_captions_precheck_ignore_all = /** @type {(inputs: Embed_Captions_Precheck_Ignore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout ignorer`)
};

const de_embed_captions_precheck_ignore_all = /** @type {(inputs: Embed_Captions_Precheck_Ignore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle ignorieren`)
};

const it_embed_captions_precheck_ignore_all = /** @type {(inputs: Embed_Captions_Precheck_Ignore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignora tutto`)
};

const ru_embed_captions_precheck_ignore_all = /** @type {(inputs: Embed_Captions_Precheck_Ignore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игнорировать всё`)
};

const es_embed_captions_precheck_ignore_all = /** @type {(inputs: Embed_Captions_Precheck_Ignore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar todo`)
};

const zh_cn2_embed_captions_precheck_ignore_all = /** @type {(inputs: Embed_Captions_Precheck_Ignore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忽略所有`)
};

const ja_embed_captions_precheck_ignore_all = /** @type {(inputs: Embed_Captions_Precheck_Ignore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて無視`)
};

const hi_embed_captions_precheck_ignore_all = /** @type {(inputs: Embed_Captions_Precheck_Ignore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी को अनदेखा करें`)
};

const pt_pt2_embed_captions_precheck_ignore_all = /** @type {(inputs: Embed_Captions_Precheck_Ignore_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar tudo`)
};

/**
* | output |
* | --- |
* | "Ignore All" |
*
* @param {Embed_Captions_Precheck_Ignore_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_precheck_ignore_all = /** @type {((inputs?: Embed_Captions_Precheck_Ignore_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Precheck_Ignore_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_precheck_ignore_all(inputs)
	if (locale === "de") return de_embed_captions_precheck_ignore_all(inputs)
	if (locale === "it") return it_embed_captions_precheck_ignore_all(inputs)
	if (locale === "ru") return ru_embed_captions_precheck_ignore_all(inputs)
	if (locale === "es") return es_embed_captions_precheck_ignore_all(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_precheck_ignore_all(inputs)
	if (locale === "ja") return ja_embed_captions_precheck_ignore_all(inputs)
	if (locale === "hi") return hi_embed_captions_precheck_ignore_all(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_precheck_ignore_all(inputs)
	return en_embed_captions_precheck_ignore_all(inputs)
});